import React, { createContext, useContext, ReactNode } from 'react';
import { ConfigProvider, ThemeConfig } from 'antd';

// 定义主题上下文类型
interface ThemeContextType {
  theme: ThemeConfig;
}

// 创建主题上下文
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

// 浅色主题配置
const lightTheme: ThemeConfig = {
  token: {
    colorPrimary: '#658bff',
    colorBgContainer: '#ffffff',
    colorText: '#333333',
    colorTextSecondary: '#666666',
    fontSize: 14,
    borderRadius: 4,
  },
  components: {
    Button: {
      colorPrimary: '#658bff',
      borderRadius: 4,
    },
    Card: {
      borderRadius: 6,
      colorBgContainer: '#f9f9f9',
    },
    // 可以根据需要添加更多组件的样式配置
  },
};

// 主题提供者组件
interface LightThemeProviderProps {
  children: ReactNode;
}

export const LightThemeProvider: React.FC<LightThemeProviderProps> = ({
  children,
}) => {
  const value = {
    theme: lightTheme,
  };

  return (
    <ThemeContext.Provider value={value}>
      <ConfigProvider theme={lightTheme}>
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};

// 自定义 Hook 用于在组件中使用主题
export const useLightTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useLightTheme must be used within a LightThemeProvider');
  }
  return context;
};
